import lazyLoad from '@loadable/component'
import createPlugin from './createPlugin'
import ButtonsRenderer from '@peracto/peracto-blocks-tailwind/dist/content/Buttons/Renderer/ButtonsRenderer'

const ButtonsForm = lazyLoad(() => import('./Form/ButtonsForm'))

const buttonsPlugin = settings =>
    createPlugin({
        Renderer: ButtonsRenderer,
        Controls: ButtonsForm,
        ...settings,
    })

const buttons = buttonsPlugin()
export default buttons

export { buttonsPlugin, ButtonsRenderer }
